module.exports = __webpack_public_path__ + "img/83.3dfdf22d.jpg";